import React from "react";
import { useMitsol } from "./MitsolLayout";
import { PageHero, Section } from "./_shared";
import { Phone, Mail, MapPin, Clock, Send } from "lucide-react";

export default function Contact() {
  const data = useMitsol();
  const inst = data?.institute || {};
  const address = "Tuljapur Road, Tale Hipparga, Ta. North Solapur, Dist. Solapur, Maharashtra";
  const mapQuery = encodeURIComponent(`Marathwada Private Industrial Training Institute Solapur, ${address}`);

  return (
    <div data-testid="mitsol-contact">
      <PageHero
        eyebrow="Get in Touch"
        title="Visit our campus, or reach us online"
        sub="We welcome parents, students and industry partners at our Tuljapur Road campus any working day. Reach us via phone or email — our admissions cell responds promptly."
      />
      <Section>
        <div className="grid md:grid-cols-[1.1fr_1fr] gap-8">
          <div className="space-y-4">
            <Row icon={<MapPin />} label="Address">
              {address}
            </Row>
            {inst.admission_phone && (
              <Row icon={<Phone />} label="Phone">
                <a href={`tel:${inst.admission_phone.replace(/\s+/g, "")}`} className="hover:text-[#F97316]">{inst.admission_phone}</a>
              </Row>
            )}
            {inst.email && (
              <Row icon={<Mail />} label="Email">
                <a href={`mailto:${inst.email}`} className="hover:text-[#F97316] break-all">{inst.email}</a>
              </Row>
            )}
            <Row icon={<Clock />} label="Office Hours">
              Monday – Saturday · 10:00 am – 5:00 pm<br />
              <span className="text-xs text-slate-500">Closed on public holidays</span>
            </Row>
            <div className="grid grid-cols-2 gap-3 pt-2">
              <a href={`tel:${(inst.admission_phone || "").replace(/\s+/g, "")}`} className="inline-flex items-center justify-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white font-bold text-sm uppercase tracking-wider px-5 py-3.5 transition-colors" data-testid="mitsol-contact-call">
                <Phone size={14} /> Call Now
              </a>
              <a href={`mailto:${inst.email || ""}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#0F2A47] text-[#0F2A47] font-bold text-sm uppercase tracking-wider px-5 py-3.5 hover:bg-[#0F2A47] hover:text-white transition-colors" data-testid="mitsol-contact-email">
                <Send size={14} /> Email Us
              </a>
            </div>
          </div>
          <div>
            <div className="border border-slate-200 overflow-hidden aspect-[4/3] bg-slate-100">
              <iframe
                title="MIT (ITI) Solapur — Map"
                src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="mitsol-contact-map"
              />
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}

function Row({ icon, label, children }) {
  return (
    <div className="bg-white border border-slate-200 p-5 flex items-start gap-4">
      <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-[#F97316]/10 text-[#F97316]">{icon}</div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-slate-500 font-bold">{label}</div>
        <div className="mt-1 text-sm text-slate-800 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
